import React from 'react';
import { packagesData } from '../CustomData/packagesData';
import '../selfcss/package.css';

function Packages() {
    return (
        <div className="container-xxl py-5" id="packages">
            <div className="container">
                <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                    <h6 className="section-title bg-white text-center text-primary px-3">
                        Packages
                    </h6>
                    <h1 className="mb-5">Exclusive Travel Packages</h1>
                </div>
                <div className="row g-4 justify-content-center">
                    {packagesData.map((pkg) => (
                        <div
                            key={pkg.id}
                            className="col-lg-4 col-md-6 wow fadeInUp"
                            data-wow-delay="0.1s"
                        >
                            <div className="package-item">
                                <div className="overflow-hidden">
                                    <img className="img-fluid package-img" src={pkg.image} alt={pkg.title} />
                                </div>
                                <div className="d-flex border-bottom">
                                    <small className="flex-fill text-center border-end py-2">
                                        <i className="fa fa-map-marker-alt text-primary me-2" />
                                        {pkg.title}
                                    </small>
                                    <small className="flex-fill text-center border-end py-2">
                                        <i className="fa fa-calendar-alt text-primary me-2" />
                                        {pkg.duration}
                                    </small>
                                    <small className="flex-fill text-center py-2">
                                        <i className="fa fa-user text-primary me-2" />
                                        {pkg.people}
                                    </small>
                                </div>
                                <div className="text-center p-4">
                                    <h3 className="mb-0">{pkg.price}</h3>
                                    <p>{pkg.description}</p>
                                    <p><strong>Car Type:</strong> {pkg.car}</p>
                                    <div className="d-flex justify-content-center mb-2">
                                        <a
                                            href="/contact"
                                            className="btn btn-sm btn-primary px-3 border-end"
                                            style={{ borderRadius: "30px 0 0 30px", cursor: "pointer" }}
                                        >
                                            Query?
                                        </a>
                                        <a
                                            href="/booknow"
                                            className="btn btn-sm btn-primary px-3"
                                            style={{ borderRadius: "0 30px 30px 0", cursor: "pointer" }}
                                        >
                                            Book Now
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Packages;